import React, { useState } from 'react'
import { Descriptions } from 'antd'
import { Badge, Button } from 'reactstrap'
import moment from 'moment'
import EditFaqModal from './EditFaqModal'

const { Item } = Descriptions

export default function FaqDetailsWidget({ faq, reload }) {
	const [showEditModal, setShowEditModal] = useState(false)

	return (
		<React.Fragment>
			<Descriptions size="small" column={1}>
				<Item>
					{faq.disabled_at ? <Badge color='danger'>Oculto</Badge> : <Badge color='success'>Visible</Badge>}
				</Item>
				<Item label="Pregunta">{faq.question}</Item>
				<Item label="Respuesta">{faq.answer}</Item>
				<Item label="ID Pregunta">#00{faq.id}</Item>
				<Item label="Fecha Creación">{moment(faq.created_at).format('YYYY-MM-DD HH:mm')}</Item>
				<Item label="Fecha Última Modificación">{moment(faq.updated_at).format('YYYY-MM-DD HH:mm')}</Item>
			</Descriptions>
			<div className='mt-2'>
				<Button color="primary" outline onClick={() => setShowEditModal(true)}>
					Actualizar Datos
				</Button>
			</div>
			{ showEditModal && (
				<EditFaqModal
					visible
					onClose={() => setShowEditModal(false)}
					faq={faq}
					reload={() => {
						setShowEditModal(false)
						reload()
					}}
				/>
			)}
		</React.Fragment>
	)
}